import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgError(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("circle", {
      cx: 32,
      cy: 32,
      r: 28,
      stroke: "#7373FF",
      strokeWidth: 3
    }, void 0), _jsx("path", {
      d: "M22 22l19.699 19.899M42 22L22.301 41.899",
      stroke: "#FF6652",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, void 0)]
  }), void 0);
}

export default SvgError;